import { setMarketsInOpponent } from 'app/pages/EventsPage/EventsPageContent/MatchListContainer/MatchList/utils';
import type { MatchPreviewData, MatchPreviewTeam } from 'app/components/MatchPreview/types';

import type { MonitoredMarket, MonitoringDeleteMessage, MonitoringMessage } from './types';

const getOpponentsOutcome = (
  outcomes: Outcome[],
  opponents: [PandapiPlayer | PandapiTeam, PandapiPlayer | PandapiTeam]
): [Outcome | null, Outcome | null] => {
  const outcome1 = outcomes.find(outcome => outcome.participant_id === opponents[0].id) || null;
  const outcome2 = outcomes.find(outcome => outcome.participant_id === opponents[1].id) || null;

  return [outcome1, outcome2];
};

const messageIsDeleteMessage = (message: MonitoringMessage): message is MonitoringDeleteMessage =>
  message.action === 'delete';

const allMessagesAreDelete = (
  messages: MonitoringMessage[]
): messages is MonitoringDeleteMessage[] => messages.every(messageIsDeleteMessage);

const monitoredMarketToMarket = (
  market: MonitoredMarket,
  selections: TypeWithRequired<Outcome, 'probability_with_margin'>[],
  name: string
): Market => ({
  ...market.pandascore_market,
  overround: market.pandascore_market.margin,
  selections: selections.map(selection => ({
    ...selection,
    probability_with_overround: selection.probability_with_margin,
    name: selection.template.toUpperCase()
  })),
  category: '',
  dynamic_line: false,
  enabled: true,
  event_id: market.game ? market.game.id : market.match.id,
  event_type: market.game ? 'game' : 'match',
  is_micromarket: false,
  is_prebuilt: false,
  name,
  pandascore_status: 'active',
  participant_id: null,
  participant_type: null,
  reviewed: true,
  status: 'active',
  suspension_override: false,
  videogame_slug: market.videogame_slug,
  is_live: true,
  is_preevent: true
});

const getFormatedMatch = (
  match: Pick<PandapiMatch, 'id' | 'name' | 'opponents' | 'scheduled_at'>,
  status?: MarketStatus
): Pick<MatchPreviewData, 'markets_status' | 'competitors' | 'status' | 'id'> => ({
  ...match,
  competitors: [],
  status: 'pre_match',
  markets_status: status
    ? { 'map-handicap': status, 'map-over-under': status, winner: status }
    : undefined
});

const getFormatedTeams =
  (
    opponents: [PandapiPlayer | PandapiTeam, PandapiPlayer | PandapiTeam],
    displayedMarket: MatchPreviewDisplayedMarket
  ) =>
  (market: Market) => {
    const formatedTeams = opponents.map((opponent, index) => {
      const newOpponent = { ...opponent };

      return setMarketsInOpponent(
        newOpponent,
        {
          'map-handicap': undefined,
          'map-over-under': undefined,
          winner: undefined,
          [displayedMarket]: market
        },
        index
      );
    }) as [MatchPreviewTeam, MatchPreviewTeam];

    return formatedTeams;
  };

export {
  getOpponentsOutcome,
  allMessagesAreDelete,
  monitoredMarketToMarket,
  getFormatedMatch,
  getFormatedTeams
};
